"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountriesByCountryCodes = exports.countryMap = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FlagAU_1 = __importDefault(require("./flags/FlagAU"));
const FlagCA_1 = __importDefault(require("./flags/FlagCA"));
const FlagIE_1 = __importDefault(require("./flags/FlagIE"));
const FlagNZ_1 = __importDefault(require("./flags/FlagNZ"));
const FlagUK_1 = __importDefault(require("./flags/FlagUK"));
const FlagUS_1 = __importDefault(require("./flags/FlagUS"));
const countries = [
    { name: 'Australia', flag: (0, jsx_runtime_1.jsx)(FlagAU_1.default, {}), code: 'AU', dialCode: '+61' },
    { name: 'United States', flag: (0, jsx_runtime_1.jsx)(FlagUS_1.default, {}), code: 'US', dialCode: '+1' },
    { name: 'New Zealand', flag: (0, jsx_runtime_1.jsx)(FlagNZ_1.default, {}), code: 'NZ', dialCode: '+64' },
    { name: 'United Kingdom', flag: (0, jsx_runtime_1.jsx)(FlagUK_1.default, {}), code: 'GB', dialCode: '+44' },
    { name: 'Canada', flag: (0, jsx_runtime_1.jsx)(FlagCA_1.default, {}), code: 'CA', dialCode: '+1' },
    { name: 'Ireland', flag: (0, jsx_runtime_1.jsx)(FlagIE_1.default, {}), code: 'IE', dialCode: '+353' },
];
exports.countryMap = new Map([
    ['AU', { name: 'Australia', flag: (0, jsx_runtime_1.jsx)(FlagAU_1.default, {}), code: 'AU', dialCode: '+61' }],
    ['US', { name: 'United States', flag: (0, jsx_runtime_1.jsx)(FlagUS_1.default, {}), code: 'US', dialCode: '+1' }],
    ['CA', { name: 'Canada', flag: (0, jsx_runtime_1.jsx)(FlagCA_1.default, {}), code: 'CA', dialCode: '+1' }],
    ['NZ', { name: 'New Zealand', flag: (0, jsx_runtime_1.jsx)(FlagNZ_1.default, {}), code: 'NZ', dialCode: '+64' }],
    ['GB', { name: 'United Kingdom', flag: (0, jsx_runtime_1.jsx)(FlagUK_1.default, {}), code: 'GB', dialCode: '+44' }],
    ['IE', { name: 'Ireland', flag: (0, jsx_runtime_1.jsx)(FlagIE_1.default, {}), code: 'IE', dialCode: '+353' }],
]);
const getCountriesByCountryCodes = (countryCodes) => {
    return countryCodes
        .filter(countryCode => exports.countryMap.has(countryCode))
        .map(countryCode => exports.countryMap.get(countryCode));
};
exports.getCountriesByCountryCodes = getCountriesByCountryCodes;
exports.default = countries;
